<template></template>
<script>
import areaListData from "@/utils/Area.js";
import { wxRequest } from '@/api/user'
import { Toast } from 'vant';
import { Dialog } from 'vant';
export default {
    data() {
        return {

        }
    }, 
    created() {
        window.location.href ="http://wx.519liuliang.com/#/newUser/simKefu";
    },
}
</script>
<style lang="less" scoped>
.vantBody {
    max-width: 540px;
    margin: 0 auto;
    height: 100%;
    position: relative;

    .viewImg {
        img {
            height: 100%;
            width: 100%;
            display: block;
        }
    }

    .el-btn {
        position: fixed;
        width: 100%;
        height: 70px;
        background: #fff;
        bottom: 0;
        text-align: center;
        line-height: 60px;

        .btnButton {
            width: 92%;
            text-align: center;
            height: 50px;
            line-height: 78px;
            color: #fff;
            background-image: -webkit-linear-gradient(45deg, #E6322E, rgb(255, 26, 97)) !important;
            background-image: linear-gradient(45deg, #E6322E, rgb(255, 26, 97)) !important;
            font-size: 18px;
            border: none;
            -webkit-animation: templateEnlargeShrink 3s infinite;
            -o-animation: templateEnlargeShrink 3s infinite;
            animation: templateEnlargeShrink 3s infinite;
            border-radius: 25px;
        }

        .template-enhance-animation-light {
            background: url(../../assets/activity/light_animate.png);
            position: absolute;
            top: 10px;
            width: 6.1625rem;
            height: 3rem;
            animation: templateSearchLights 3s linear infinite forwards;
            -webkit-transform-style: preserve-3d;
            -webkit-backface-visibility: hidden;
            -webkit-perspective: 1000;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            background-size: 6.1625rem 3.8125rem;
        }
    }

    .sumbit {
        text-align: center;
        padding: 8px 0;
        position: relative;

        .sumbitSave {
            width: 92%;
            text-align: center;
            height: 50px;
            line-height: 78px;
            background-image: -webkit-linear-gradient(45deg, #E6322E, rgb(255, 26, 97)) !important;
            background-image: linear-gradient(45deg, #E6322E, rgb(255, 26, 97)) !important;
            -webkit-animation: templateEnlargeShrink 3s infinite;
            -o-animation: templateEnlargeShrink 3s infinite;
            animation: templateEnlargeShrink 3s infinite;
            border: none;
            color: #fff;
            font-size: 18px;
            border-radius: 25px;
        }

        .template-enhance-animation-light {
            background: url(../../assets/activity/light_animate.png);
            position: absolute;
            top: 10px;
            width: 6.1625rem;
            height: 3rem;
            animation: templateSearchLights 3s linear infinite forwards;
            -webkit-transform-style: preserve-3d;
            -webkit-backface-visibility: hidden;
            -webkit-perspective: 1000;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
            background-size: 6.1625rem 3.8125rem;
        }
    }

    .bottom-popup {
        padding: 40px 0 10px 0;

        .van-cell-group {
            margin: 0 auto;

            &::after {
                border: none
            }
        }
    }

    .small {
        font-size: 10px;
        padding: 6px 16px 10px 16px;
        color: #666;
    }

    .form-tips {
        width: 80px;
        height: 30px;
        line-height: 30px;
        padding-left: 15px;
        padding-bottom: 2px;
        font-size: 15px;
        font-weight: 600;
        background: url('../../assets/activity/icon6.png') no-repeat left bottom;
        background-size: 100%;
        color: #333;
        border-radius: 15px;
        margin-bottom: 6px;
    }

    .checkbox-info {
        width: 93%;
        margin: 10px auto;
        font-size: 12px;
        color: #fff;

        .van-checkbox {
            display: inline-block;
            vertical-align: middle;
            margin-right: 10px;
        }
    }
}

@keyframes templateEnlargeShrink {
    0% {
        transform: scale(1);
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
    }

    33% {
        transform: scale(0.95);
        -webkit-transform: scale(0.95);
        -ms-transform: scale(0.95);
    }

    66% {
        transform: scale(1);
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
    }

    100% {
        transform: scale(1);
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
    }
}

@keyframes templateSearchLights {
    0% {
        transform: translate(-5.66123188rem);
        -webkit-transform: translate(-5.66123188rem);
        opacity: 0;
    }

    66% {
        transform: translate(-5.66123188rem);
        -webkit-transform: translate(-5.66123188rem);
        opacity: 1;
    }

    100% {
        transform: translate(24.90942029rem);
        -webkit-transform: translate(24.90942029rem);
    }
}</style>